"use client";

import { useAppStore } from "@/store/useAppStore";
import React, { useEffect, useState } from "react";
import { FeedbackModal } from "./modals/FeedbackModal";

export const ChallengeMode = () => {
  const {
    challengeMode,
    userScore,
    setChallengeMode,
  } = useAppStore();

  const [showChallengeIntro, setShowChallengeIntro] = useState(false);
  const [challengeData, setChallengeData] = useState<{
    challengerName: string;
    targetScore: number;
  } | null>(null);

  useEffect(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const challengeId = urlParams.get("challenge");
    const challengerName = urlParams.get("challenger");
    const targetScore = urlParams.get("score");

    if (challengeId && challengerName && targetScore) {
      const decodedName = decodeURIComponent(challengerName);
      const scoreNumber = parseInt(targetScore);

      setChallengeMode({
        active: true,
        challengerId: challengeId,
        challengerName: decodedName,
        targetScore: scoreNumber,
      });
      alert(
        `🎯 Challenge from ${decodeURIComponent(
          challengerName
        )}!\n\nBeat their score of ${targetScore} points to win!`
      );
      setChallengeData({
        challengerName: decodedName,
        targetScore: scoreNumber,
      });
      setShowChallengeIntro(true);
    }
  }, []);

  const handleChallengeIntroClose = () => {
    setShowChallengeIntro(false);
    setChallengeData(null);
  };

  if (!challengeMode) {
    return null;
  }
  return (
    <>
      <div className="bg-gradient-to-r from-brand-amber to-brand-teal text-white py-4 px-6 text-center">
        <p className="text-lg font-bold">
          🎯 Challenge Mode Active! Beat {challengeMode.challengerName}'s score
          of {challengeMode.targetScore} points!
        </p>
        {userScore >= challengeMode.targetScore && (
          <p className="text-sm mt-2">
            🎉 Congratulations! You've beaten the challenge! Share your victory!
          </p>
        )}
      </div>

      {showChallengeIntro && challengeData && (
        <FeedbackModal
          type="info"
          handleContinue={handleChallengeIntroClose}
          showConfetti={false}
        >
          <div className="text-6xl mb-4">🎯</div>
          <h2 className="text-2xl font-bold text-white mb-4">
            Challenge Received!
          </h2>
          <p className="text-gray-200 mb-6 leading-relaxed">
            <span className="text-brand-accent font-semibold">
              {challengeData.challengerName}
            </span>{" "}
            has challenged you to beat their score!
          </p>

          <div className="bg-brand-teal/20 rounded-lg p-4 mb-6 border border-brand-teal/30">
            <div className="text-lg font-bold text-white mb-2">
              🏆 Target Score
            </div>
            <div className="text-3xl font-bold text-yellow-400">
              {challengeData.targetScore} points
            </div>
          </div>

          <div className="bg-blue-500/20 rounded-lg p-3 mb-4 border border-blue-500/30">
            <div className="text-blue-300 text-sm space-y-1">
              <div>
                💡 <strong>How to win:</strong> Score higher than{" "}
                {challengeData.targetScore} points
              </div>
              <div>
                🎮 <strong>Game on:</strong> Answer challenges to earn points
              </div>
              <div>
                🏅 <strong>Victory:</strong> Beat the score and claim bragging
                rights!
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-400">
            Good luck! Your current score:{" "}
            <span className="text-green-400 font-semibold">
              {userScore} points
            </span>
          </div>
        </FeedbackModal>
      )}
    </>
  );
};
